var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.8333 23.3333H24.5167L24.05 22.8833C25.0916 21.6732 25.8528 20.2479 26.2792 18.7093C26.7057 17.1707 26.7867 15.5569 26.5167 13.9833C25.7333 9.34996 21.8667 5.64996 17.2 5.08329C15.5593 4.87573 13.893 5.04624 12.3284 5.58177C10.7638 6.1173 9.3424 7.00366 8.17304 8.17301C7.00369 9.34237 6.11733 10.7637 5.5818 12.3283C5.04627 13.8929 4.87576 15.5593 5.08332 17.2C5.64999 21.8666 9.34999 25.7333 13.9833 26.5166C15.5569 26.7867 17.1707 26.7056 18.7093 26.2792C20.2479 25.8528 21.6733 25.0915 22.8833 24.05L23.3333 24.5166V25.8333L30.4167 32.9166C31.1 33.6 32.2167 33.6 32.9 32.9166C33.5833 32.2333 33.5833 31.1166 32.9 30.4333L25.8333 23.3333ZM15.8333 23.3333C11.6833 23.3333 8.33332 19.9833 8.33332 15.8333C8.33332 11.6833 11.6833 8.33329 15.8333 8.33329C19.9833 8.33329 23.3333 11.6833 23.3333 15.8333C23.3333 19.9833 19.9833 23.3333 15.8333 23.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundSearch);
export default __webpack_public_path__ + "static/media/ic_round-search.a639ef74baddce588df34d6432e3397c.svg";
export { ForwardRef as ReactComponent };